import { useList } from '@refinedev/core';
import { useEffect, useMemo, useState } from 'react';
import { Calendar } from 'src/meetings/models';

export const useCalendars = () => {
  const [connecting, setConnecting] = useState(false);

  const { data, isLoading, error, refetch } = useList<Calendar>({
    resource: 'calendars',
    queryOptions: {
      refetchInterval: connecting ? 2000 : undefined,
    },
  });

  const calendars = data?.data || [];

  const connectedCalendars = useMemo(() => {
    return calendars.filter(c => c.status === 'CONNECTED');
  }, [calendars]);
  const disconnectedCalendars = useMemo(() => {
    return calendars.filter(c => c.status === 'DISCONNECTED');
  }, [calendars]);

  const latestIsConnecting = calendars.some(isCalendarConnecting);
  useEffect(() => {
    setConnecting(latestIsConnecting);
  }, [latestIsConnecting]);

  return {
    calendars,
    connectedCalendars,
    disconnectedCalendars,
    refetch,
    connecting: latestIsConnecting,
    justConnected: connecting && !latestIsConnecting,
    isLoading,
    error,
  };
};

const isCalendarConnecting = (calendar: Calendar): boolean => {
  return (
    calendar.status === 'CONNECTING' ||
    (calendar.status === 'CONNECTED' && !calendar.eventFirstSyncedAt)
  );
};
